export const Checkbox = {
    variants: {
        ironhack: {
            control: {
                _checked: {
                    _disabled: {
                        bg: 'trasparent',
                        borderColor: 'stroke.medium',
                        color: 'stroke.medium'
                    },
                    _hover: {
                        bg: 'trasparent',
                        borderColor: 'stroke.interactive'
                    },
                    bg: 'trasparent',
                    borderColor: 'stroke.interactive',
                    color: 'stroke.interactive'
                },
                _disabled: {
                    bg: 'trasparent',
                    borderColor: 'stroke.medium',
                    color: 'stroke.medium'
                },
                _focusVisible: {
                    boxShadow: 'var(--chakra-colors-purple-100) 0px 0px 0px 4px'
                },
                _indeterminate: {
                    bg: 'trasparent',
                    borderColor: 'stroke.interactive',
                    color: 'stroke.interactive'
                },
                _invalid: {
                    bg: 'trasparent',
                    borderColor: 'stroke.error',
                    color: 'stroke.error'
                },
                border: '2px solid',
                borderColor: 'stroke.dark',
                borderRadius: '3px',
                h: '20px',
                w: '20px'
            },
            label: {
                textStyle: 'm',
                _disabled: {
                    color: 'text.tertiary',
                    opacity: 1
                }
            }
        }
    },
    parts: [
        'icon',
        'container',
        'control',
        'label'
    ],
    defaultProps: {
        variant: 'ironhack'
    }
};

//# sourceMappingURL=checkbox.js.map